import { useEffect, useState } from "react";
import { toast } from "sonner";
import { usePoll } from "@/hooks/usePoll";
import { api, errMsg } from "@/lib/api";
import { PageHeader } from "@/components/Badges";

const Toggle = ({ label, desc, checked, onChange, testid }) => (
  <label className="flex items-start justify-between gap-6 py-3 border-b border-zinc-100 cursor-pointer">
    <span><span className="block text-sm font-medium text-zinc-900">{label}</span><span className="block text-xs text-zinc-500">{desc}</span></span>
    <input type="checkbox" className="mt-1 h-4 w-4 accent-[#7C3AED]" checked={checked} onChange={(e) => onChange(e.target.checked)} data-testid={testid} />
  </label>
);

export default function SystemSettings() {
  const { data } = usePoll("/admin/system-settings", 0);
  const [f, setF] = useState(null);
  useEffect(() => { data && setF(data); }, [data]);
  if (!f) return <p className="label-xs">Loading…</p>;
  const set = (k, v) => setF({ ...f, [k]: v });
  const save = async () => {
    try { await api.put("/admin/system-settings", { ...f, default_paper_balance: Number(f.default_paper_balance) }); toast.success("System settings saved"); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const inp = "w-full bg-white border border-zinc-200 rounded-sm px-3 py-2 text-sm focus:outline-none focus:border-[#7C3AED]";
  return (
    <div data-testid="admin-system-page" className="max-w-2xl">
      <PageHeader title="System Settings" sub="Super Admin only · changes are recorded in the activity log" />
      <div className="panel p-5 space-y-4">
        <div>
          <Toggle label="Allow new registrations" desc="When off, the trader sign-up form is closed." checked={f.allow_registration} onChange={(v) => set("allow_registration", v)} testid="sys-allow-registration" />
          <Toggle label="Require approval for new accounts" desc="New traders stay pending until a staff member approves them." checked={f.registration_requires_approval} onChange={(v) => set("registration_requires_approval", v)} testid="sys-require-approval" />
        </div>
        <label className="block space-y-1"><span className="label-xs">Default paper-trading balance (new accounts)</span>
          <input type="number" className={`${inp} num`} value={f.default_paper_balance} onChange={(e) => set("default_paper_balance", e.target.value)} data-testid="sys-default-balance" /></label>
        <label className="block space-y-1"><span className="label-xs">Announcement banner (shown to all traders, leave empty to hide)</span>
          <input className={inp} value={f.maintenance_banner} onChange={(e) => set("maintenance_banner", e.target.value)} data-testid="sys-banner-input" /></label>
        <label className="block space-y-1"><span className="label-xs">Support email</span>
          <input className={inp} value={f.support_email} onChange={(e) => set("support_email", e.target.value)} data-testid="sys-support-email" /></label>
        <button onClick={save} className="px-5 py-2 bg-[#7C3AED] hover:bg-[#6D28D9] text-white text-sm font-semibold rounded-sm transition-colors" data-testid="sys-save-btn">Save system settings</button>
      </div>
    </div>
  );
}
